// Brand lockup: deployment wordmark on the left, "Powered by" platform logo on the right.
// The two logos stay separate assets so the platform trademark is never recolored or redrawn.
// Falls back to the legacy single-image banner when no deployment logo is configured.
const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default function StudioBrand({ branding, compact = false, bannerClassName = "digital-twin-banner" }) {
  const { deployment, platform, attribution } = branding;
  const name = deployment.name || "Studio";

  if (!deployment.logo) {
    if (!deployment.banner) return null;
    return <img className={bannerClassName} src={deployment.banner} alt={`${name} brand banner`} />;
  }

  // "Powered by HACaMS" -> "Powered by" (the logo already says HACaMS)
  const poweredLabel = attribution.text
    ? attribution.text.replace(new RegExp(`\s*${escapeRegExp(platform.name)}\s*$`, "i"), "").trim() || attribution.text
    : "Powered by";

  return (
    <header className={`studio-brand${compact ? " studio-brand-compact" : ""}`}>
      <div className="studio-brand-main">
        <img className="studio-brand-wordmark" src={deployment.logo} alt={name} />
        {deployment.descriptor && <p className="studio-brand-descriptor">{deployment.descriptor}</p>}
        {deployment.tagline && <p className="studio-brand-tagline">{deployment.tagline}</p>}
      </div>
      {platform.logo && (
        <div className="studio-brand-powered">
          <span className="studio-brand-powered-label">{poweredLabel}</span>
          <img className="studio-brand-platform-logo" src={platform.logo} alt={platform.name} />
          {platform.tagline && <span className="studio-brand-platform-tagline">{platform.tagline}</span>}
        </div>
      )}
    </header>
  );
}
